import React from 'react';
import styles from './SelectedValue.module.scss';
import { content } from '../../constants/constants';

const SelectedValue = ({ value }) => {
  if (!value) return null;

  return (
    <div className={styles.container}>
      <div className={styles.title}>
        Звонок, который вы выбрали для привязки:
      </div>
      <div className={styles.content}>
        {content.map((item) => (
          <div
            key={item.key}
            className={styles.headers}
          >
            {item.title}
          </div>
        ))}
        {content.map((item) => item.render(value))}
      </div>
    </div>
  );
};

export default SelectedValue;
